import { Routes } from '@angular/router';
import { SvsectionFormComponent } from './svsection-form/svsection-form.component';
import { SvsectionListComponent } from './svsection-list/svsection-list.component';
import { SvquestionComponent } from './svquestion/svquestion.component';
import { SVQUESTION_ROUTES } from './svquestion/svquestion.router';


export const SVSECTION_ROUTES: Routes = [
    { path: 'list/:idsurvey', component: SvsectionListComponent },
    { path: 'add/:idsurvey', component: SvsectionFormComponent },
    { path: 'edit/:id', component: SvsectionFormComponent },
    { path: 'question', component:  SvquestionComponent, children: SVQUESTION_ROUTES},
    { path: '**', pathMatch: 'full', redirectTo: 'list'}
];